import { useState } from "react";
import { QrCode, RotateCw } from "lucide-react";

export function FlashcardPreview({ card }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="[perspective:1600px]">
      <div className={`card-flip relative w-full aspect-[1.414/1] ${flipped ? "is-flipped" : ""}`}>
        {/* Vorderseite */}
        <div className="card-face absolute inset-0 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm p-5 flex flex-col">
          <div className="flex items-center justify-between">
            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
              Karte {card.number}
            </span>
            <span className="text-[10px] uppercase tracking-wider text-blue-500 font-semibold">Vorderseite</span>
          </div>
          <h3 className="font-display font-bold text-slate-900 dark:text-slate-100 mt-2 leading-snug">
            {card.title || "—"}
          </h3>
          <div className="mt-3 text-[10px] font-bold uppercase tracking-wider text-blue-600 dark:text-blue-400">Frage</div>
          <p className="mt-1 text-sm text-slate-700 dark:text-slate-300 leading-relaxed overflow-hidden">
            {card.question}
          </p>
        </div>

        {/* Rückseite */}
        <div className="card-face card-face-back absolute inset-0 rounded-xl border border-slate-200 dark:border-slate-700 bg-[#F8FAF8] dark:bg-slate-900 shadow-sm p-5 flex flex-col">
          <div className="flex items-center justify-between">
            <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">Antwort</span>
            <span className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">Rückseite</span>
          </div>
          <p className="mt-1.5 text-[13px] text-slate-700 dark:text-slate-300 leading-relaxed overflow-hidden flex-1">
            {card.answer}
          </p>
          <div className="mt-2 flex items-end justify-between gap-3">
            <div className="min-w-0">
              <div className="text-[9px] font-bold uppercase tracking-wider text-slate-400">Quellen</div>
              <div className="text-[11px] font-mono text-slate-500 dark:text-slate-400 truncate">
                {card.citations?.length ? card.citations.map((n) => `(${n})`).join(" ") : "—"}
              </div>
            </div>
            <div className="shrink-0 grid place-items-center h-12 w-12 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300">
              <QrCode className="h-6 w-6" />
            </div>
          </div>
        </div>
      </div>

      <button
        data-testid={`card-flip-button-${card.id}`}
        onClick={() => setFlipped((f) => !f)}
        className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 py-2 text-xs font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
      >
        <RotateCw className="h-3.5 w-3.5" />
        {flipped ? "Frage zeigen" : "Antwort zeigen"}
      </button>
    </div>
  );
}
